/*
    Imports the Cockpit API URL from the config.
*/
import { API_CONFIG } from '../config.js';

export default {
	/* GET /api/v1/customers */
	getCustomers: function () {
		return axios.get(API_CONFIG.API_URL + '/customers');
	},

	/* GET	/api/v1/customer/{customerID} */
	getCustomer: function (customerID) {
		return axios.get(API_CONFIG.API_URL + '/customer/' + customerID);
	},

	/* POST	/api/v1/customers */
	postAddNewCustomer: function (name, nda, industryID, corporateGroupID) {
		return axios.post(API_CONFIG.API_URL + '/customer', {
			name: name,
			nda: nda,
			industry_id: industryID,
			corporate_group_id: corporateGroupID
		});
	},

	/* PUT 	/api/v1/customer/{id} */
	putEditCustomer: function (id, name, nda, industryID, corporateGroupID) {
		return axios.put(API_CONFIG.API_URL + '/customer/' + id, {
			name: name,
			id: id,
			nda: nda,
			industry_id: industryID,
			corporate_group_id: corporateGroupID
		});
	},

	/* DELETE	/api/v1/customer/{customerID} */
	deleteCustomer: function (customerID) {
		return axios.delete(API_CONFIG.API_URL + '/customer/' + customerID);
	}
};
